export function FrontLauncherIcon() {
  return (
    <span aria-hidden="true" className="relative block h-5 w-5">
      <span className="absolute bottom-0 left-0 h-3.5 w-4 rounded-[4px] bg-white" />
      <span className="absolute bottom-[-3px] left-1 h-2 w-2 rotate-45 rounded-[1px] bg-white" />
      <span className="absolute right-0 top-0 h-3.5 w-4 rounded-[4px] bg-white" />
      <span className="absolute bottom-1 right-[3px] h-2 w-2 rotate-45 rounded-[1px] bg-white" />
      <span className="absolute bottom-1 left-1 h-1.5 w-3 rounded-[3px] bg-[#a785ff]" />
    </span>
  );
}
